export default __webpack_public_path__ + "static/media/austria.e0982f04.svg";